import React, { FC } from 'react';
import TextSwatch from 'au-gatsby-ds/components/SwatchSelect/TextSwatch';
import FoilColorSwatch from '../components/ProductOption/FoilColorSwatch';
import CircularImageSwatch from '../components/ProductOption/CircularImageSwatch';
import SquareImageSwatch from '../components/ProductOption/SquareImageSwatch';
import {
  FieldRenderType,
  getLowestPageCountOptionValue,
  getMaxPageCount,
  getPricePerPageOrSpread
} from '../../pdp/helpers';
import { SwatchProps } from 'au-gatsby-ds/components/SwatchSelect/types';
import { ProductType } from 'features/pdp/types/event';
import { getDiscountPriceByPercent } from 'helpers/strikethroughPricing';
import { numberToUSD } from 'helpers/currency';
import { SKU_HARDCOVER } from 'components/constants/products';
import { isSpreadBook } from 'helpers/products';

//TODO (Depending on EN-10162 test result): Grab this dyanmically
const HARCOVER_MAX_PAGE_COUNT = 210;

const SWATCH_COMPONENTS: Record<string, FC<SwatchProps>> = {
  [FieldRenderType.SwatchText]: TextSwatch,
  [FieldRenderType.TextSwatch]: TextSwatch,
  [FieldRenderType.ImageSwatch]: CircularImageSwatch,
  [FieldRenderType.FoilSwatch]: FoilColorSwatch,
  [FieldRenderType.BooksizeSwatch]: SquareImageSwatch
};

const SQUARE_IMAGE_SWATCH_LABELS: string[] = ['calendar_design'];

const isSquareImageSwatchLabel = (label: string): boolean =>
  !!SQUARE_IMAGE_SWATCH_LABELS.find((squareLabel) => label && label.includes(squareLabel));

export const getComponentForProductOption = (type: string, label: string): FC<SwatchProps> => {
  if (isSquareImageSwatchLabel(label)) {
    return SquareImageSwatch;
  }
  return SWATCH_COMPONENTS[type] || TextSwatch;
};

export const isTextSwatch = (type: string, label: string): boolean =>
  !isSquareImageSwatchLabel(label) && (type === FieldRenderType.SwatchText || type === FieldRenderType.TextSwatch);

export const getAlbumSizeDescription = (
  product: ProductType,
  optionId: string,
  selectedOptionId: string,
  showVariantPagePricing = false
): JSX.Element => {
  let costPerPage = getPricePerPageOrSpread(product, optionId, selectedOptionId, showVariantPagePricing);
  if (!costPerPage || isNaN(costPerPage)) {
    return;
  }
  if (isSpreadBook(product.hammerCategory)) {
    costPerPage /= 2;
  }
  const discountedRate = getDiscountPriceByPercent(product, costPerPage);
  const costPerPageLabel = discountedRate ? (
    <>
      {numberToUSD(discountedRate)} <span className="strikethrough-price">{numberToUSD(costPerPage)}</span>
    </>
  ) : (
    numberToUSD(costPerPage)
  );

  const basePageCount = getLowestPageCountOptionValue(product, true);
  if (!basePageCount || isNaN(basePageCount)) {
    return;
  }

  //TODO (Depending on EN-10162 test result): Grab max page dynamically for product,
  // OR grab entire description from option
  const maxPageCount = product.sku === SKU_HARDCOVER ? HARCOVER_MAX_PAGE_COUNT : getMaxPageCount(product, true);
  if (!maxPageCount) {
    return;
  }

  return (
    <>
      Includes {basePageCount} pages. Add more for {costPerPageLabel}/page, up to {maxPageCount} pages total.
    </>
  );
};
